/**
 * 国际化引导文件
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'      //  国际化
import Storage from 'store2'        //  本地存储

//  element-ui
import elementUiLocale from 'element-ui/lib/locale'

//  dayjs
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import updateLocale from 'dayjs/plugin/updateLocale'

import zhCN from './lang/zh-CN'   //  中文
import enUS from './lang/en-US'   //  英文

//  设置默认语言
export const defaultLang = Storage.get('lang') || 'zh-CN'

//  如果是英文，element-ui 需要设置语言
if (defaultLang == 'en-US') {
  elementUiLocale.use(enUS.elementUiLang)
}

//  dayjs 设置语言
dayjs.extend(localeData)
dayjs.locale(defaultLang.toLowerCase());

const messages = {
  'zh-CN': {
    ...zhCN
  },
  'en-US': {
    ...enUS
  },
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

/**
 * 设置语言
 * @param {*} lang 
 * @returns 
 */
function setI18nLanguage(lang) {
  i18n.locale = lang
  // request.headers['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

/**
 * 切换语言
 * @param {*} lang 中文：zh-CN；英文：en-US
 * @returns 
 */
export function loadLanguageAsync(lang = defaultLang) {
  return new Promise(resolve => {
    // 缓存语言设置
    Storage.set('lang', lang)

    if (i18n.locale !== lang) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
        const locale = msg.default
        i18n.setLocaleMessage(lang, locale)
        //  设置 element-ui 语言
        elementUiLocale.use(locale.elementUiLang)

        //  dayjs 设置语言
        dayjs.extend(updateLocale)
        dayjs.locale(lang.toLowerCase())
        dayjs.updateLocale(lang.toLowerCase(), locale.dayjsLocale)
        return setI18nLanguage(lang)
      })
    }
    return resolve(lang)
  })
}

/**
 * 暴露在外面可以根据key来获得语言内容
 * @param {*} key 
 * @returns 
 */
export function i18nRender(key) {
  return i18n.t(`${key}`)
}

export default i18n
